var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sys-content-mange',{attrs:{"actionType":_vm.ACTION_TYPE.system}})
}
var staticRenderFns = []

export { render, staticRenderFns }